module.exports = __webpack_public_path__ + "static/IMG_0866-b80b09863a2ae8958ff3c3adabb79ace.jpg";